


import { useState } from "react";

export default function Section9() {
  const [isOpen, setIsOpen] = useState(new Array(5).fill(false));
  const handleFaq = (index) => {
    setIsOpen((prevState) =>
      prevState.map((item, idx) => (idx === index ? !item : false))
    );
  };

  return (
    <div className="w-full Section8 mt-[8%] md:mt-[4%]">
      <div className="w-full section8-container">
        <div className="w-[90%] md:w-[61%] pb-[1%] mx-auto text-center">
          <h2 className="leading-[29px] md:leading-[41px] text-[24px] md:text-[34px] text-[#151515] font-bold my-[0.67em]">
            Frequently Asked Questions About WordPress Development in UAE
          </h2>
        </div>
        <div className="w-full md:w-[784px] p-5 md:p-[2%] mx-auto faq-container font-open leading-[21px]">

          {/* FAQ 1 */}
          <div
            className="faq-item text-[11px] md:text-sm rounded-[8px] p-[2%] border border-solid border-[#DEDEDE] mb-[4%]"
            style={{
              background:
                "linear-gradient(0deg, #FEFFFF, #FEFFFF), linear-gradient(0deg, #DEDEDE, #DEDEDE)",
            }}
          >
            <div
              onClick={() => handleFaq(0)}
              className="question text-[#444444] cursor-pointer flex justify-between items-center"
            >
              How long does it take to build a WordPress website in Dubai?
              <b className="text-[40px] text-[#DA2128] font-[300]">{isOpen[0] ? "-" : "+"}</b>
            </div>
            <div className={`${isOpen[0] ? "block" : "hidden"} answer text-[#444444]`}>
              <br />
              <p className="mb-5">
                Most WordPress websites take around 4–6 weeks, depending on the project’s size and complexity. We provide a detailed project plan and clear milestones before development begins.
              </p>
            </div>
          </div>

          {/* FAQ 2 */}
          <div
            className="faq-item text-[11px] md:text-sm rounded-[8px] p-[2%] border border-solid border-[#DEDEDE] mb-[4%]"
            style={{
              background:
                "linear-gradient(0deg, #FEFFFF, #FEFFFF), linear-gradient(0deg, #DEDEDE, #DEDEDE)",
            }}
          >
            <div
              onClick={() => handleFaq(1)}
              className="question text-[#444444] cursor-pointer flex justify-between items-center"
            >
             What is the cost of WordPress website development in the UAE?
              <b className="text-[40px] text-[#DA2128] font-[300]">{isOpen[1] ? "-" : "+"}</b>
            </div>
            <div className={`${isOpen[1] ? "block" : "hidden"} answer text-[#444444]`}>
              <br />
              <p className="mb-5">
                The cost depends on your website’s design, features, and goals. We provide transparent, customized quotes for each project to match your budget and business objectives.
              </p>
            </div>
          </div>

          {/* FAQ 3 */}
          <div
            className="faq-item text-[11px] md:text-sm rounded-[8px] p-[2%] border border-solid border-[#DEDEDE] mb-[4%]"
            style={{
              background:
                "linear-gradient(0deg, #FEFFFF, #FEFFFF), linear-gradient(0deg, #DEDEDE, #DEDEDE)",
            }}
          >
            <div
              onClick={() => handleFaq(2)}
              className="question text-[#444444] cursor-pointer flex justify-between items-center"
            >
              Do you offer bilingual (English and Arabic) WordPress websites?
              <b className="text-[40px] text-[#DA2128] font-[300]">{isOpen[2] ? "-" : "+"}</b>
            </div>
            <div className={`${isOpen[2] ? "block" : "hidden"} answer text-[#444444]`}>
              <br />
              <p className="mb-5">
               Yes, we specialize in developing bilingual websites optimized for both English and Arabic users which is ideal for the UAE’s multilingual audience.
              </p>
            </div>
          </div>

          {/* FAQ 4 */}
          <div
            className="faq-item text-[11px] md:text-sm rounded-[8px] p-[2%] border border-solid border-[#DEDEDE] mb-[4%]"
            style={{
              background:
                "linear-gradient(0deg, #FEFFFF, #FEFFFF), linear-gradient(0deg, #DEDEDE, #DEDEDE)",
            }}
          >
            <div
              onClick={() => handleFaq(3)}
              className="question text-[#444444] cursor-pointer flex justify-between items-center"
            >
              Can you optimize my WordPress site for SEO in Dubai?
              <b className="text-[40px] text-[#DA2128] font-[300]">{isOpen[3] ? "-" : "+"}</b>
            </div>
            <div className={`${isOpen[3] ? "block" : "hidden"} answer text-[#444444]`}>
              <br />
              <p className="mb-5">
                Absolutely. We build SEO-friendly WordPress websites that target relevant UAE keywords and follow Google best practices, helping your business rank higher in local searches.
              </p>
            </div>
          </div>

          {/* FAQ 5 */}
          <div
            className="faq-item text-[11px] md:text-sm rounded-[8px] p-[2%] border border-solid border-[#DEDEDE] mb-[4%]"
            style={{
              background:
                "linear-gradient(0deg, #FEFFFF, #FEFFFF), linear-gradient(0deg, #DEDEDE, #DEDEDE)",
            }}
          >
            <div
              onClick={() => handleFaq(4)}
              className="question text-[#444444] cursor-pointer flex justify-between items-center"
            >
              Do you provide ongoing WordPress maintenance and support in the UAE?
              <b className="text-[40px] text-[#DA2128] font-[300]">{isOpen[4] ? "-" : "+"}</b>
            </div>
            <div className={`${isOpen[4] ? "block" : "hidden"} answer text-[#444444]`}>
              <br />
              <p className="mb-5">
                Yes, our local Dubai-based team provides continuous maintenance, monitoring, and support to ensure your site stays updated, secure, and performing at its best.
              </p>
            </div>
          </div>
        </div>
      </div>
      <div className="line mb-[55px] md:mb-[4%] mt-[1%] mx-auto w-[70%] md:w-[61%] shadow-line h-2 rounded-[100%]"></div>
    </div>
  );
}